// src/pages/gene.codes/GeneticWheel/AiPanelGenerationControl.tsx
import React from "react";
import { Button, Popconfirm } from "antd";
import { ReloadOutlined, ThunderboltOutlined } from "@ant-design/icons";

import { useGeneratePanelData } from "../../../hooks/genetic/useGeneratePanelData";
import { can } from "../../../utils/userPrefs/validatePermissions";

interface AiPanelGenerationControlProps {
	sampleId: string;
	disabled?: boolean;
}

const AiPanelGenerationControl: React.FC<AiPanelGenerationControlProps> = ({ sampleId, disabled }) => {
	const generation = useGeneratePanelData();

	// labiq refuses a forced regeneration without this permission (AiPanelController::refuseUnlessMayRegenerate).
	const mayForce = can("labiq.genecodes.regenerate");
	const busy = generation.isPending;
	const blocked = busy || Boolean(disabled);

	return (
		<div className="ai-panel-generation">
			<Button
				size="small"
				icon={<ThunderboltOutlined />}
				loading={busy}
				disabled={blocked}
				data-testid="ai-panel-generate"
				title="Queue AI analysis for any panel on this sample that does not have one yet"
				onClick={() => generation.mutate({ sampleId })}
			>
				Generate AI analysis
			</Button>

			{mayForce && (
				<Popconfirm
					title="Regenerate every panel?"
					description="The existing AI reports for this sample are discarded and rewritten, and a full multi-panel generation runs."
					okText="Regenerate"
					okButtonProps={{ danger: true }}
					cancelText="Cancel"
					disabled={blocked}
					onConfirm={() => generation.mutate({ sampleId, force: true })}
				>
					<Button size="small" danger icon={<ReloadOutlined />} disabled={blocked} data-testid="ai-panel-force">
						Regenerate all
					</Button>
				</Popconfirm>
			)}
		</div>
	);
};

export default AiPanelGenerationControl;
